import styled from 'styled-components';

export const ContainerStyled = styled.div`
	background-color: white;
	text-align: center;
	padding: 10px;
	border-radius: 5px;
`;
